var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.name.length),function(n){return _c('div',{key:n,staticClass:"w-full xl:w-4/12 p-2"},[_c('card-chart-name',{attrs:{"name":_vm.name[--n],"position":n}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }